angular.module("vgresiduos").directive("disposalComplementaryMtr", function () {
	return {
		scope: true,
		controller: "DisposalComplementaryMtrCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalComplementaryMtr/disposalComplementaryMtr_template.html"
	};
});
